/* Native card swatches and forms remain in charge. This element follows their exact variant ID. */
if (!customElements.get('collection-offer')) {
  customElements.define('collection-offer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.eligible = new Set((this.dataset.eligible || '').split(',').filter(Boolean));
      this.card = this.closest('product-card, variant-card');
      this.card?.addEventListener('change', event => {
        const id = event.target.dataset.variantId;
        if (id) this.update(id);
      }, {signal: this.controller.signal});
      this.update(this.dataset.selected);
    }
    update(id) {
      const eligible = this.eligible.has(String(id));
      this.querySelector('[data-offer-current]').hidden = !eligible;
      this.querySelector('[data-offer-other]').hidden = eligible;
      this.dataset.selected = id;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
